$(($) => {
	const activeCareerMenuItem = $(
		'#mega-menu-main-menu > .sub-menu-added.mega-current_page_item'
	);

	if (activeCareerMenuItem.length > 0) {
		$('body').addClass('has-inner-menu');
	}

	$(window).bind('resize load', () => {
		setTimeout(() => {
			const innerMenuHeight = $(
				'#mega-menu-main-menu > .sub-menu-added.mega-current_page_item > ul.mega-sub-menu'
			).outerHeight();
			const headerHeight = $('header').outerHeight();
			const socialShareTop = $(
				'.bs-column--social-share .heateor_sss_horizontal_sharing'
			);
			if ($('body').hasClass('has-inner-menu')) {
				$('main').css(
					'margin-top',
					`${innerMenuHeight + headerHeight - 1}px`
				);
				socialShareTop.css(
					'top',
					`${innerMenuHeight + headerHeight + 17}px`
				);
			}
		}, 10);
	});
});
